import { makeYearMonthPickerFilter } from '@octopus/ui/data-grid';

export const usePeriodFilter = () => {
  return makeYearMonthPickerFilter({
    label: 'Competência',
    propertyToFilter: 'period',
  });
};
